import { render } from "./IconContainer.vue?vue&type=template&id=ccaa2ff0&scoped=true"
import script from "./IconContainer.vue?vue&type=script&lang=js"
export * from "./IconContainer.vue?vue&type=script&lang=js"

import "./IconContainer.vue?vue&type=style&index=0&id=ccaa2ff0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccaa2ff0"],['__file',"src/components/IconContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ccaa2ff0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ccaa2ff0', __exports__)) {
    console.log('reload')
    api.reload('ccaa2ff0', __exports__)
  }
  
  module.hot.accept("./IconContainer.vue?vue&type=template&id=ccaa2ff0&scoped=true", () => {
    console.log('re-render')
    api.rerender('ccaa2ff0', render)
  })

}


export default __exports__